import PersonalizationConfig from "./PersonalizationConfig";

const DefaultPersonalizationConfig: PersonalizationConfig = {
    branding: "salus",
    complexity: "full",
};

export default DefaultPersonalizationConfig;